import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import '../styles/index.css'
import {
	MDBCol,
	MDBRow,
} from 'mdb-react-ui-kit';
import Femovate from '../img/femovate_badge_light.png'
import "../styles/footer.css"

export const NewFooter = ({show}) => {
	return (
		<div>
	{show &&
		<div className="bg-footer">
		<div className="show-big-screen">
		<MDBRow between >
        <MDBCol size='4' className="d-flex m-3">
		<Link to="/" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Home</p></Link>
		<Link to="/Individual" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Individual</p></Link>
		<Link to="/Practitioner" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Practitioner</p></Link>
		<Link to="/about" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">About</p></Link>
		<Link to="/browse" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Browse</p></Link>
		<Link to="/terms" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Terms</p></Link>
		<Link to="/practitionerLogin" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Login</p></Link>
		<Link to="/privacyPolicy" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 textfoot text-dm">Privacy Policy</p></Link>
        </MDBCol>
        <MDBCol size='4' className="d-flex icons-left">
		<a classname="a-link-footer" target="_blank" rel="noreferrer" href="https://www.femtechux.com/femovate">
		<img src={Femovate} alt="femovate-sticker" className="me-4 femovateIconDesktop" />
		</a>
		<a className="a-link-footer me-3 icon" href="https://www.facebook.com/helloelana/"><i className="fab fa-facebook-square"/></a>
		<a className="a-link-footer me-3 icon" href="https://www.linkedin.com/company/elanahealth/"><i className="fab fa-linkedin"/></a>
		<a className="a-link-footer me-3 icon" href="https://www.pinterest.com/elanahealth/"><i className="fab fa-pinterest"/></a>
		<a className="a-link-footer me-3 icon" href="https://www.instagram.com/elana.health/"><i className="fab fa-instagram"/></a>
        </MDBCol>
      </MDBRow>
	  </div>

	  <div className="show-responsive">
	  <MDBRow around>
	  <MDBCol size='4'>
		<Link to="/" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Home</p></Link>
        <Link to="/Individual" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Individual</p></Link>
		<Link to="/Practitioner" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Practitioner</p></Link>
		<Link to="/about" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">About</p></Link>
        </MDBCol>
        <MDBCol size='4'>
		<Link to="/browse" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Browse</p></Link>
		<Link to="/terms" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Terms</p></Link>
		<Link to="/practitionerLogin" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 text-dm">Login</p></Link>
		<Link to="/privacyPolicy" className="text-decoration-none text-white m-0 p-0 ms-3"><p className="m-0 textfoot text-dm">Privacy Policy</p></Link>
        </MDBCol>
      </MDBRow>
	  <MDBCol size='4' className="d-flex justify-content-start ms-1 ">
		<a className="a-link-footer me-2 icon p-2" href="https://www.facebook.com/helloelana/"><i className="fab fa-facebook-square"/></a>
		<a className="a-link-footer me-2 icon p-2" href="https://www.linkedin.com/company/elanahealth/"><i className="fab fa-linkedin"/></a>
		<a className="a-link-footer me-2 icon p-2" href="https://www.pinterest.com/elanahealth/"><i className="fab fa-pinterest"/></a>
		<a className="a-link-footer me-2 icon p-2" href="https://www.instagram.com/elana.health/"><i className="fab fa-instagram"/></a>
		<div className="h-100 d-flex justify-content-center align-items-center">
			<a classname="a-link-footer" target="_blank" rel="noreferrer" href="https://www.femtechux.com/femovate">
			<img src={Femovate} alt="femovate-sticker" className="femovateIconMobile femovateIconMobileMargin ms-4" />
			</a>
		</div>
        </MDBCol>
	  </div>
	  </div> }
	  </div>
	)
}
NewFooter.propTypes = {
	show: PropTypes.bool,
  };
NewFooter.defaultProps = {
	show: true
  };